/**
 * Client-side mirror of the supported payout countries.
 *
 * Source of truth lives in `supabase/functions/_shared/stripeConnectPolicy.ts`;
 * any change there must be reflected here so the wallet UI can gate the flow
 * before any external call is made.
 */

// Sandbox/MVP scope: the Stripe platform is registered in the US, so we can
// only create Connect accounts for US-based instructors right now. BR (and any
// other country) is gated client-side until the platform expands.
const SUPPORTED_COUNTRY_SLUGS = new Set<string>([
  'united-states',
  'usa',
  'us',
]);

export function isPayoutCountrySupported(country: string | null | undefined): boolean {
  if (!country) return false;
  return SUPPORTED_COUNTRY_SLUGS.has(country.trim().toLowerCase());
}
